import React, { useState, useEffect } from 'react';
import { useSoundworlds } from '../../hooks/useSoundworlds';

interface SoundworldModalProps {
    onClose: () => void;
    onSelect: (soundworldName: string) => void;
}

export const SoundworldModal: React.FC<SoundworldModalProps> = ({ onClose, onSelect }) => {
    const { soundworlds, isLoading } = useSoundworlds();
    const [selectedSoundworld, setSelectedSoundworld] = useState<string | null>(null);

    const handleSelect = (soundworldName: string) => {
        setSelectedSoundworld(soundworldName);
        onSelect(soundworldName);
        onClose();
    };

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50" onClick={ onClose }>
            <div className="bg-card rounded-lg p-6 max-w-5xl w-full max-h-[90vh] overflow-y-auto" onClick={ (e) => e.stopPropagation() }>
                <div className="flex justify-between items-center mb-4">
                    <h2 className="text-lg font-semibold text-card-foreground">Choose Your Soundworld</h2>
                    <button onClick={ onClose } className="text-muted-foreground text-xl">&times;</button>
                </div>

                { isLoading ? (
                    <div className="text-center py-8">
                        <div className="w-8 h-8 border-4 border-muted border-t-primary rounded-full animate-spin mx-auto"></div>
                        <p className="text-muted-foreground mt-2">Loading soundworlds...</p>
                    </div>
                ) : (
                    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4">
                        { soundworlds.map((sw) => (
                            <div
                                key={ sw.id }
                                onClick={ () => handleSelect(sw.id) }
                                className="relative rounded-xl cursor-pointer overflow-hidden hover:shadow-md border border-border transition"
                                style={ {
                                    backgroundImage: sw.image ? `url(${sw.image})` : 'url(https://images.unsplash.com/photo-1506744038136-46273834b3fb?auto=format&fit=crop&w=800&q=80)',
                                    backgroundSize: 'cover',
                                    backgroundPosition: 'center',
                                    height: '180px'
                                } }
                            >
                                <div className="absolute inset-0 bg-black bg-opacity-50"></div>
                                <div className="absolute bottom-0 p-4 text-white z-10">
                                    <div className="flex items-center gap-2 font-semibold text-sm">
                                        { sw.name_pretty }
                                    </div>
                                    <div className="text-xs mt-1 opacity-90">{ sw.subtitle }</div>
                                    { sw.author && (
                                        <div className="text-xs mt-1 opacity-75">by { sw.author }</div>
                                    ) }
                                </div>
                            </div>
                        )) }
                    </div>
                ) }
            </div>
        </div>
    );
};
